import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-[#050505] text-slate-200">
      <header className="glass border-b border-white/5 sticky top-0 z-40">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center justify-between">
          <Link to="/" data-testid="legal-back" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white"><ArrowLeft size={16} /> Back to home</Link>
          <Link to="/" className="font-display font-bold text-white">ECO</Link>
        </div>
      </header>
      <article className="max-w-3xl mx-auto px-5 py-12 md:py-16">
        <span className="font-mono-eco text-xs uppercase tracking-widest text-slate-500">Entrepreneur OS</span>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-white tracking-tight mt-2">{title}</h1>
        <p className="text-xs font-mono-eco uppercase tracking-widest text-slate-500 mt-3">Last updated: {updated}</p>
        <div className="mt-10 space-y-8">{children}</div>
        <div className="mt-12 pt-6 border-t border-white/5 text-sm text-slate-400">
          Questions about this policy? Contact us at{" "}
          <a href="mailto:ecoentrepreneuros@gmail.com" className="text-[#4d8bff] hover:underline">ecoentrepreneuros@gmail.com</a>.
        </div>
        <div className="mt-6 flex gap-4 text-sm">
          <Link to="/terms" className="text-slate-500 hover:text-white">Terms of Service</Link>
          <Link to="/privacy" className="text-slate-500 hover:text-white">Privacy Policy</Link>
        </div>
      </article>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-lg font-semibold text-white mb-2.5">{title}</h2>
      <div className="space-y-2.5 text-sm leading-relaxed text-slate-300">{children}</div>
    </section>
  );
}
